var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25,
    r: 24.25,
    fill: "white",
    stroke: "#ED2028",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.666 25.3613H13.666",
    stroke: "#ED2028",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8633 19L12.5014 25.3618L18.8633 31.7237",
    stroke: "#ED2028",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/prevArrow.0dec3c3cb3b200e08d07c6321dc1bb25.svg";
export { ForwardRef as ReactComponent };